/* assets/bb-delivery.js */
(() => {
  const variantInput = document.querySelector("form[action^='/cart/add'] input[name='id']");
  if (!variantInput) return;

  // Try to safely extract section ID (if wrapped in an identifiable product-form-xxxx)
  let sectionId = null;
  const parentForm = variantInput.closest("[id^='product-form-']");
  if (parentForm && typeof parentForm.id === "string") {
    sectionId = parentForm.id.replace("product-form-", "");
  }

  // Try to find meta JSON and box with or without section ID
  const metaJSON = sectionId
    ? document.querySelector(`#bb-variant-meta-${sectionId}`)
    : document.querySelector("[id^='bb-variant-meta-']");

  const box = sectionId
    ? document.getElementById(`bb-delivery-box-${sectionId}`)
    : document.querySelector(".bb-delivery-box");

  if (!metaJSON || !box) return;

  const span = box.querySelector(".bb-delivery-range");
  if (!span) return;

  let variantsMeta = [];
  try {
    variantsMeta = JSON.parse(metaJSON.textContent || "[]");
  } catch (e) {
    console.warn("Failed to parse variant metafields", e);
    return;
  }

  const getMeta = (id) => variantsMeta.find((v) => v.id === id);

  // ❌ OLD (business days) – removed
  // const addBizDays = (d, n) => { ... };

  // ✅ NEW: add plain calendar days (week = full 7 days)
  const addDays = (d, n) => {
    const date = new Date(d);
    date.setDate(date.getDate() + n);
    return date;
  };

  const fmt = (d) =>
    d.toLocaleDateString(undefined, {
      day: "2-digit",
      month: "short"
    });

  function render(id) {
    const vm = getMeta(id);
    if (!vm || vm.available === false) {
      box.hidden = true;
      return;
    }

    // lead_min_weeks/lead_max_weeks already represent full weeks.
    const min = (vm.lead_min_days || 0) + (vm.lead_min_weeks || 0) * 7;
    const max = (vm.lead_max_days || 0) + (vm.lead_max_weeks || 0) * 7;

    if (min === 0 && max === 0) {
      box.hidden = true;
      return;
    }

    const today = new Date();
    const minDate = addDays(today, min);
    const maxDate = addDays(today, max);

    span.textContent = `${fmt(minDate)} – ${fmt(maxDate)}`;
    box.hidden = false;
  }

  // Initial render
  const variantId = parseInt(variantInput.value, 10);
  if (variantId) render(variantId);

  // For multi-variant support
  const vo = document.querySelector("variant-options");
  if (vo) {
    vo.addEventListener("variantChangeEnd", () => {
      render(vo.currentVariant?.id || variantInput.value);
    });
  }
})();
